export const newPageNotificationModal = {
	title: "More security for your tax data!",
	content: "Now, whenever a tax registration is created or changed by Zig,",
	contentEmphasis:
		"you'll be able to review and validate the data before it's used.",
	primaryActionLabel: "See what's new",
};
